import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend, { ChainedBackendOptions } from 'i18next-chained-backend';
import HttpApi from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

// Namespaces organization:
// `translation` will be the default namespace where shared translations will be located. Will be a file per language.
// Each module of the app should have a separate file per language.
// Example: auth module will have a locales/en/auth.json file.

// Build version for cache busting - changes on each build/deploy
const CACHE_VERSION = `v${Date.now()}`;

// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
void i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .init<ChainedBackendOptions>({
    ns: 'common',
    // Remove this configuration when we have more than 1 language
    // Currently we only have english language. The browsers are
    // sending their current lang. if it is not english on the third attempt
    // it fallback to english. Make no sense to have language detector if we
    // only have english for the moment
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    backend: {
      backends: [LocalStorageBackend, HttpApi],
      backendOptions: [
        {
          projectId: 'helix-builder',
          defaultVersion: CACHE_VERSION,
          // versions must be set for cache invalidation to work
          // when the version doesn't match, cache is invalidated and fresh data is fetched
          versions: {
            en: {
              auth: CACHE_VERSION,
              common: CACHE_VERSION,
              community_outreach: CACHE_VERSION,
              dashboard: CACHE_VERSION,
              genetic_counseling: CACHE_VERSION,
              'my-account': CACHE_VERSION,
              'study-insights': CACHE_VERSION,
              teams: CACHE_VERSION,
              withdrawal: CACHE_VERSION,
            },
          },
        },
        {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
      ],
      cacheHitMode: 'refreshAndUpdateStore',
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
